import React, { createContext, useState, useContext } from 'react';

const SignupModalContext = createContext();

export const SignupModalProvider = ({ children }) => {
  const [showSignupModal, setShowSignupModal] = useState(false);

  const openSignupModal = () => {
    setShowSignupModal(true);
  };

  const closeSignupModal = () => {
    setShowSignupModal(false);
  };

  return (
    <SignupModalContext.Provider value={{ 
      showSignupModal, 
      openSignupModal, 
      closeSignupModal 
    }}>
      {children}
    </SignupModalContext.Provider>
  );
};

export const useSignupModal = () => {
  const context = useContext(SignupModalContext);
  if (!context) {
    throw new Error('useSignupModal must be used within a SignupModalProvider');
  }
  return context;
}; 